export default "__VITE_ASSET__CTcpAlNQ__"